import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/geometric/cdf';
import __var_2__ from '@stdlib/stats/base/dists/geometric/ctor';
import __var_3__ from '@stdlib/stats/base/dists/geometric/entropy';
import __var_4__ from '@stdlib/stats/base/dists/geometric/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/geometric/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/geometric/logpmf';
import __var_7__ from '@stdlib/stats/base/dists/geometric/mean';
import __var_8__ from '@stdlib/stats/base/dists/geometric/median';
import __var_9__ from '@stdlib/stats/base/dists/geometric/mgf';
import __var_10__ from '@stdlib/stats/base/dists/geometric/mode';
import __var_11__ from '@stdlib/stats/base/dists/geometric/pmf';
import __var_12__ from '@stdlib/stats/base/dists/geometric/quantile';
import __var_13__ from '@stdlib/stats/base/dists/geometric/skewness';
import __var_14__ from '@stdlib/stats/base/dists/geometric/stdev';
import __var_15__ from '@stdlib/stats/base/dists/geometric/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace geometric
*/
var geometric = {};

/**
* @name cdf
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/cdf}
*/
setReadOnly( geometric, 'cdf', __var_1__);

/**
* @name Geometric
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/ctor}
*/
setReadOnly( geometric, 'Geometric', __var_2__);

/**
* @name entropy
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/entropy}
*/
setReadOnly( geometric, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/kurtosis}
*/
setReadOnly( geometric, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/logcdf}
*/
setReadOnly( geometric, 'logcdf', __var_5__);

/**
* @name logpmf
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/logpmf}
*/
setReadOnly( geometric, 'logpmf', __var_6__);

/**
* @name mean
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/mean}
*/
setReadOnly( geometric, 'mean', __var_7__);

/**
* @name median
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/median}
*/
setReadOnly( geometric, 'median', __var_8__);

/**
* @name mgf
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/mgf}
*/
setReadOnly( geometric, 'mgf', __var_9__);

/**
* @name mode
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/mode}
*/
setReadOnly( geometric, 'mode', __var_10__);

/**
* @name pmf
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/pmf}
*/
setReadOnly( geometric, 'pmf', __var_11__);

/**
* @name quantile
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/quantile}
*/
setReadOnly( geometric, 'quantile', __var_12__);

/**
* @name skewness
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/skewness}
*/
setReadOnly( geometric, 'skewness', __var_13__);

/**
* @name stdev
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/stdev}
*/
setReadOnly( geometric, 'stdev', __var_14__);

/**
* @name variance
* @memberof geometric
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/geometric/variance}
*/
setReadOnly( geometric, 'variance', __var_15__);


// EXPORTS //
export default geometric;

export { __var_1__ as cdf, __var_2__ as Geometric, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpmf, __var_7__ as mean, __var_8__ as median, __var_9__ as mgf, __var_10__ as mode, __var_11__ as pmf, __var_12__ as quantile, __var_13__ as skewness, __var_14__ as stdev, __var_15__ as variance};